// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.bybit",
    name: "Bybit Wallet",
    homepage: "https://www.bybit.com/web3/",
    image_id: "b9e64f74-0176-44fd-c603-673a45ed5b00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/US/app/id1488296980",
        android: "https://play.google.com/store/apps/details?id=com.bybit.app&hl=en",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/bybit-wallet/pdliaogehgdbhbnmkklieghmmjkpigpa",
        firefox: null,
        safari: null,
        edge: "https://chrome.google.com/webstore/detail/bybit-wallet/pdliaogehgdbhbnmkklieghmmjkpigpa",
        opera: null,
    },
    rdns: "com.bybit",
    mobile: {
        native: "bybitapp://open/route?targetUrl=by://web3/walletconnect/",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map